import { RouteObject } from "react-router";
import { Layout } from "../components";
import {
  StatPage,
  LoginPage,
  BalancePage,
  SettingsPage,
  Providers,
  TransactionPage,
  Merchants,
  LogsPage,
  CascadesPage,
  UsersPage,
  PaymentMethodsPage,
  CurrenciesPage,
  ProviderCredentialsPage,
} from "../pages";
import { ProtectedRoute } from "../components";
export const createAppRoutes = (
  isDark: boolean,
  setIsDark: React.Dispatch<React.SetStateAction<boolean>>,
): RouteObject[] => [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <Layout isDark={isDark} setIsDark={setIsDark} />,
        children: [
          { path: "/", element: <StatPage /> },
          { path: "providers", element: <Providers /> },
          { path: "cascades", element: <CascadesPage /> },
          { path: "balances", element: <BalancePage /> },
          { path: "settings", element: <SettingsPage /> },
          { path: "stats", element: <StatPage /> },
          { path: "merchants", element: <Merchants /> },
          { path: "transactions", element: <TransactionPage /> },
          { path: "logs", element: <LogsPage /> },
          { path: "users", element: <UsersPage /> },
          { path: "payment-methods", element: <PaymentMethodsPage /> },
          { path: "currencies", element: <CurrenciesPage /> },
          { path: "provider-keys", element: <ProviderCredentialsPage /> },
        ],
      },
    ],
  },
];
